import React, { useContext, useState } from "react"
import { ContentContainer, SummaryLabels } from "../../../../../styles/orderform.tsx"
import { OrderContext } from "../../OrderContext.tsx"
import { getVariation } from "../../../../../misc/helpers.ts";
import ErrorWrapper from "./ErrorWrapper.tsx";
import IconAlertCircle from '../../../../../assets/images/icon-alert-circle.svg';

import { styled } from 'styled-components';
import { bp } from "../../../../../styles/breakPoints.tsx";
import { useTranslation } from "react-i18next";

const EmailInfoBox = styled.div`

    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media ${bp.md} {
      flex-direction: row;
      align-items: flex-start;
    }

    .text {
      border: solid 2px var(--Ametisti);
      padding: 8px;
      border-radius: 0 6px 6px 6px;
      font-weight: 400;
    }

    .purple {
      color: var(--Ametisti);
      font-weight: 700;
    }

    img {
      display: flex;
      justify-content: center;
      padding: 8px;
      background-color: var(--Ametisti);
      border-radius: 6px 6px 0 0;

      @media ${bp.md} {
        border-radius: 6px 0 0 6px;
      }
    }
`;

function Terms({ showError }: { showError?: boolean }) {
  const { formValues, setFormValues, handleFormChange, products } = useContext(OrderContext);
  const { t } = useTranslation();
  const [selectedProduct] = useState(getVariation({ products, contractTemplateId: formValues['product'] }));

  const [acceptMarketing, setAcceptMarketing] = useState(formValues['accept-sms-marketing'] == 'on' || formValues['accept-email-marketing'] == 'on');

    const handleMarketingChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const checked = e.target.checked;
      if (!checked) {
        setFormValues({ ...formValues, 'accept-sms-marketing': '', 'accept-email-marketing': '' });
      }
      setAcceptMarketing(e.target.checked);
    }

  return (
    <>
      <h2>{t('terms.confirmOrder')}</h2>
      <p>{t('terms.confirmDesc')}</p>

      <SummaryLabels>
        <ErrorWrapper showError={!!showError}>
          <label className={"checkbox-label terms-label" + (showError ? ' invalid' : '')}>
            <input type="checkbox" name="accept-terms" checked={formValues['accept-terms'] === 'on'} onChange={handleFormChange} />
            <span className="description" dangerouslySetInnerHTML={{ __html: t('terms.acceptTerms', { 
                termsLink: selectedProduct?.override_terms_link ? selectedProduct.override_terms_link : "https://www.lumme-energia.fi/sahkosopimus/yleista-sopimusehdoista",
                privacyLink: "https://www.lumme-energia.fi/tietosuojaseloste"
              }) }}>
            </span>
          </label>
        </ErrorWrapper>
        <div>
          <label className="checkbox-label terms-label">
            <input type="checkbox" name="accept-marketing" checked={acceptMarketing} onChange={handleMarketingChange} />
            <span className="description">{t('terms.marketingText')}</span>
          </label>
          {acceptMarketing && (
            <ContentContainer>
              <div>
                <label className="checkbox-label">
                  <input type="checkbox" name="accept-email-marketing" checked={formValues['accept-email-marketing'] == 'on'} onChange={handleFormChange} />
                  <span className="description">{t('terms.email')}</span>
                </label>
              </div>
              <div>
                <label className="checkbox-label">
                  <input type="checkbox" name="accept-sms-marketing" checked={formValues['accept-sms-marketing'] == 'on'} onChange={handleFormChange} />
                  <span className="description">{t('terms.sms')}</span>
                </label>
              </div>
            </ContentContainer>
          )}
        </div>

      </SummaryLabels>

      <EmailInfoBox>
        <img src={IconAlertCircle} width={24} height={24} />
        <div className="text"><span className="purple">{t('terms.emailInfo')}</span> {t('terms.emailInfoDesc')}</div>
      </EmailInfoBox>
    </>
  )
}

export default Terms;
